import React, {Component} from 'react';
import styles from './HowItWorksSceneBackdrop.scss';
import classNames from 'classnames/bind';
import * as SceneEffects from '../../../../lib/functions/SceneEffects';

const cx = classNames.bind(styles);

class HowItWorksSceneBackdrop extends Component {
  howItWorksSceneBackdropRef;

  componentDidMount() {
    const {howItWorksSceneBackdropRef} = this;

    SceneEffects.parallaxY(howItWorksSceneBackdropRef, howItWorksSceneBackdropRef);
  }

  render() {
    return (
      <div className={cx('scene-backdrop')} ref={ref => this.howItWorksSceneBackdropRef = ref}>
        <div className={cx('dot-array')}>
          <div className={cx('factor-column', 'factor-column-temp')} data-column='temperature'>
            <span className={cx('dot', 'y5')} />
            <span className={cx('dot', 'y4')} />
            <span className={cx('dot', 'y3')} />
            <span className={cx('dot', 'y2')} />
            <span className={cx('dot', 'y1')} />
          </div>
          <div className={cx('factor-column', 'factor-column-hum')} data-column='humidity'>
            <span className={cx('dot', 'y5')} />
            <span className={cx('dot', 'y4')} />
            <span className={cx('dot', 'y3')} />
            <span className={cx('dot', 'y2')} />
            <span className={cx('dot', 'y1')} />
          </div>
          <div className={cx('factor-column', 'factor-column-co2')} data-column='co2'>
            <span className={cx('dot', 'y5')} />
            <span className={cx('dot', 'y4')} />
            <span className={cx('dot', 'y3')} />
            <span className={cx('dot', 'y2')} />
            <span className={cx('dot', 'y1')} />
          </div>
          <div className={cx('factor-column', 'factor-column-che')} data-column='chemicals'>
            <span className={cx('dot', 'y5')} />
            <span className={cx('dot', 'y4')} />
            <span className={cx('dot', 'y3')} />
            <span className={cx('dot', 'y2')} />
            <span className={cx('dot', 'y1')} />
          </div>
          <div className={cx('factor-column', 'factor-column-dust')} data-column='dust'>
            <span className={cx('dot', 'y5')} />
            <span className={cx('dot', 'y4')} />
            <span className={cx('dot', 'y3')} />
            <span className={cx('dot', 'y2')} />
            <span className={cx('dot', 'y1')} />
          </div>
          <div className={cx('score-digit', 'score-digit-tens')} data-number='4'>
            <span className={cx('dot', 'x1', 'y5')} /><span className={cx('dot', 'x2', 'y5')} /><span className={cx('dot', 'x3', 'y5')} />
            <span className={cx('dot', 'x1', 'y4')} /><span className={cx('dot', 'x2', 'y4')} /><span className={cx('dot', 'x3', 'y4')} />
            <span className={cx('dot', 'x1', 'y3')} /><span className={cx('dot', 'x2', 'y3')} /><span className={cx('dot', 'x3', 'y3')} />
            <span className={cx('dot', 'x1', 'y2')} /><span className={cx('dot', 'x2', 'y2')} /><span className={cx('dot', 'x3', 'y2')} />
            <span className={cx('dot', 'x1', 'y1')} /><span className={cx('dot', 'x2', 'y1')} /><span className={cx('dot', 'x3', 'y1')} />
          </div>
          <div className={cx('score-digit', 'score-digit-ones')} data-number='8'>
            <span className={cx('dot', 'x1', 'y5')} /><span className={cx('dot', 'x2', 'y5')} /><span className={cx('dot', 'x3', 'y5')} />
            <span className={cx('dot', 'x1', 'y4')} /><span className={cx('dot', 'x2', 'y4')} /><span className={cx('dot', 'x3', 'y4')} />
            <span className={cx('dot', 'x1', 'y3')} /><span className={cx('dot', 'x2', 'y3')} /><span className={cx('dot', 'x3', 'y3')} />
            <span className={cx('dot', 'x1', 'y2')} /><span className={cx('dot', 'x2', 'y2')} /><span className={cx('dot', 'x3', 'y2')} />
            <span className={cx('dot', 'x1', 'y1')} /><span className={cx('dot', 'x2', 'y1')} /><span className={cx('dot', 'x3', 'y1')} />
          </div>
          <span className={cx('dot', 'y3', 'score-color-dot')} data-color='poor' />
        </div>
      </div>
    );
  }
}

export default HowItWorksSceneBackdrop;


// WEBPACK FOOTER //
// ./src/app/components/organisms/HowItWorksSceneBackdrop/HowItWorksSceneBackdrop.js